import Vue from 'vue'
import Vuex from 'vuex'
import router from './router'
import {
  i18n
} from './resx'

Vue.use(Vuex)

window.baseDomain = ''
var metatag = document.querySelectorAll('meta[property="basedomain"]')
if (metatag.length > 0) {
  window.baseDomain = metatag[0].getAttribute('content')
}

export default new Vuex.Store({
  state: {
    sitemap: [],
    homepage: 'home',
    downloads: {},
    downloadGroups: [],
    availableCultures: false,
    cultures: [],
    lastTheme: {},
    previewTheme: false,
    partners: [],
    themes: [],
    contentBlocks: {},
    loadedPages: {},
    activePage: {},
    language: process.env.VUE_APP_DEFAULTCULTURE || 'nl-NL',
    loading: false,
    isAdmin: false,
    adminLanguage: 'nl-NL',
    hasContentChanges: false,
    waitingSnackbar: [],
    snackbar: false,
    publicAccidentData: false,
    gettingPublicAccidentData: false,
    staff: [],
    navbarActive: false,
    unpublishedThemes: [],
    imgBase: process.env.VUE_APP_IMGBASE || '',
    base: window.baseDomain,
    domain: 'https://www.' + window.baseDomain + '/',
    gettingLocalSitemap: false,
    country: 'NLD',
    dark: false
  },
  mutations: {
    language (state, lang) {
      if (lang) {
        document.querySelector('html').setAttribute('lang', lang.split('-')[0])
        state.language = lang
        i18n.locale = lang
      }
    },
    adminLanguage (state, lang) {
      state.adminLanguage = lang
    },
    setNavbar (state, action) {
      state.navbarActive = action
    },
    setSitemap (state, sitemap) {
      state.sitemap = sitemap
    },
    setDownloads (state, downloads) {
      state.downloads = downloads
    },
    setUnpublishedThemes (state, themes) {
      state.unpublishedThemes = themes
    },
    setThemes (state, themes) {
      state.themes = themes
    },
    setPreviewTheme (state, themes) {
      // state.previewTheme = themes
      state.previewTheme = Object.assign({}, themes)
    },
    setDownloadGroups (state, groups) {
      state.downloadGroups = groups || []
    },
    setAvailableCultures (state, cultures) {
      state.availableCultures = cultures
    },
    setCultures (state, cultures) {
      state.cultures = cultures
    },
    setLastTheme (state, theme) {
      state.lastTheme = theme
    },
    setPartners (state, partners) {
      state.partners = partners
    },
    setHomepage (state, page) {
      state.homepage = page
    },
    setContentBlocks (state, blocks) {
      state.contentBlocks = {
        ...state.contentBlocks,
        [state.language]: blocks
      }
    },
    setAdmin (state, value) {
      state.isAdmin = value
    },
    activePage (state, page) {
      state.activePage = Object.assign({}, page)
    },
    setPublicAccidentData (state, data) {
      state.publicAccidentData = data
    },
    setGettingPublicAccidentData (state, data) {
      state.gettingPublicAccidentData = data
    },
    setStaff (state, data) {
      state.staff = data
    },
    loading (state, isLoading) {
      state.loading = isLoading
    },
    contentChanged (state, changed) {
      state.hasContentChanges = changed
    }
  },
  actions: {
    setPreviewTheme (context, newTheme) {
      var tmp = {}
      context.state.lastTheme.forEach(theme => {
        if (theme.Culture === context.state.language) {
          tmp = theme
        }
      })
      if (newTheme.ID !== tmp.ID) {
        context.commit('setPreviewTheme', newTheme)
      } else {
        context.commit('setPreviewTheme', false)
      }
    },
    logout (context) {
      var self = this
      context.commit('loading', true)
      context.commit('setAdmin', false)
      window.sessionStorage.removeItem('can-edit')
      // context.commit('setSitemap', [])
      // context.commit('setPreviewTheme', false)
      // context.commit('adminLanguage', 'nl-NL')
      // context.dispatch('getSitemap').then(function () {
      //   context.dispatch('activatePage', {
      //     page: context.state.activePage.ID
      //   })
      // })
      self._vm.$auth.via_logout().then(function () {
        window.location.reload()
      })
    },
    toggleNavbar (context, action) {
      action = action || false
      if (action) {
        context.commit('setNavbar', action === 'open')
      } else {
        context.commit('setNavbar', !context.state.navbarActive)
      }
    },
    getAvailableCultures (context) {
      // var self = this
      var vm = this._vm
      return new Promise(function (resolve) {
        if (context.state.availableCultures) {
          resolve(context.state.availableCultures)
        } else {
          vm.$http({
            method: 'GET',
            url: '/culture',
            api: 'website',
            name: process.env.VUE_APP_NAME + '_' + context.state.language
          }).then(function (response) {
            var list = []
            response.data.forEach(element => {
              list[element.ID] = element
            })
            context.commit('setAvailableCultures', list)
            resolve(list)
          }).catch(function (err) {
            context.dispatch('setSnack', {
              message: err.message
            })
          })
        }
      })
    },
    publish (context, data) {
      var self = this
      var vm = self._vm
      var d = new Date(data.PublishMoment)
      var formatDate = ('0' + d.getDate()).slice(-2) + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + d.getFullYear() + ' ' + ('0' + d.getHours()).slice(-2) + ':' + ('0' + d.getMinutes()).slice(-2)

      return vm.$http({
        method: 'POST',
        url: '/publish',
        api: 'website',
        data: data,
        name: process.env.VUE_APP_NAME + '_' + context.state.language
      }).then((response) => {
        context.dispatch('setSnack', {
          message: vm.$resx('Publish.Planned', {}, context.state.language) + ' ' + formatDate
        })
      }).catch(function (err) {
        context.dispatch('setSnack', {
          message: err.message
        })
      })
    },
    setContentBlocksToPage (context, blocks) {
      var page = context.state.activePage.ID
      var lang = context.state.language
      var tmp = context.state.sitemap.slice()
      var activePage = {}
      for (var i = 0; i < tmp.length; i++) {
        if (page === tmp[i].ID) {
          tmp[i].Cultures[lang].ContentBlocks = blocks
          activePage = tmp[i]
        }
      }
      context.commit('setSitemap', tmp)
      context.commit('activePage', activePage)
    },
    changePage (context, page) {
      var tmp = context.state.sitemap.slice()
      var found = false
      for (var i = 0; i < tmp.length; i++) {
        if (page.ID === tmp[i].ID) {
          tmp[i] = page
          found = true
        }
      }
      if (!found) {
        tmp.push(page)
      }
      context.commit('setSitemap', tmp)
    },
    deletePage (context, page) {
      var tmp = context.state.sitemap.slice()
      var idx = -1
      for (var i = 0; i < tmp.length; i++) {
        if (page === tmp[i].ID) {
          idx = i
        }
      }

      if (idx > -1) {
        tmp.splice(idx, 1)
        context.commit('setSitemap', tmp)
        if (context.state.homepage === page) {
          context.dispatch('setHomepage', tmp[0].ID)
        }
      }
    },
    changeDownload (context, download) {
      var tmp = context.state.downloads.slice()
      var found = false
      for (var i = 0; i < tmp.length; i++) {
        if (download.ID === tmp[i].ID) {
          tmp[i] = download
          found = true
        }
      }
      if (!found) {
        tmp.push(download)
      }
      context.commit('setDownloads', tmp)
    },
    deleteDownload (context, download) {
      var tmp = context.state.downloads.slice()
      var idx = -1
      for (var i = 0; i < tmp.length; i++) {
        if (download === tmp[i].Link) {
          idx = i
        }
      }

      if (idx > -1) {
        tmp.splice(idx, 1)
        context.commit('setDownloads', tmp)
      }
    },
    changeBlock (context, block) {
      var tmp = context.state.contentBlocks[context.state.language].slice()
      var found = false
      var idx = -1
      for (var i = 0; i < tmp.length; i++) {
        if (block.ID === tmp[i].ID) {
          tmp[i] = block
          found = true
        }
      }
      if (!found) {
        tmp.push(block)
      }
      context.commit('setContentBlocks', tmp)

      tmp = context.state.sitemap.slice()
      for (i = 0; i < tmp.length; i++) {
        if (tmp[i].Cultures[context.state.language].hasOwnProperty('ContentBlocks')) {
          for (var j = 0; j < tmp[i].Cultures[context.state.language].ContentBlocks.length; j++) {
            var blockItem = tmp[i].Cultures[context.state.language].ContentBlocks[j]
            if (blockItem.ID === block.ID) {
              tmp[i].Cultures[context.state.language].ContentBlocks[j] = block
            }
          }
          if (context.state.activePage.ID === tmp[i].ID) {
            idx = i
          }
        }
      }
      context.commit('setSitemap', tmp)
      if (idx > -1) {
        context.commit('activePage', context.state.sitemap[idx])
      }
    },
    changeHeader (context, header) {
      var tmp = context.state.sitemap.slice()
      var idx = -1
      for (var i = 0; i < tmp.length; i++) {
        if (context.state.activePage.ID === tmp[i].ID) {
          tmp[i].Cultures[context.state.language].Header = header
          idx = i
        }
      }

      context.commit('setSitemap', tmp)
      context.commit('activePage', context.state.sitemap[idx])
    },
    setLanguage (context, lang) {
      if (context.state.language !== lang) {
        if (context.state.activePage.Cultures.hasOwnProperty(lang)) {
          context.commit('language', lang)
          router.replace({
            path: '/' + lang + '/' + (router.currentRoute.params.page || '')
          })
        } else {
          var homeIndex = -1
          for (var i = 0; i < context.state.sitemap.length; i++) {
            if (context.state.sitemap[i].ID.toLowerCase() === context.state.homepage.toLowerCase()) {
              homeIndex = i
            }
          }
          if (homeIndex > -1 && context.state.sitemap[homeIndex].Cultures.hasOwnProperty(lang)) {
            router.push({
              path: '/' + lang + '/'
            })
          } else {
            context.commit('language', context.state.language)
          }
        }
      }
    },
    activatePage (context, data) {
      return new Promise(function (resolve) {
        var index = -1
        var homeIndex = -1

        for (var i = 0; i < context.state.sitemap.length; i++) {
          var element = context.state.sitemap[i]
          if (element.ID.toLowerCase() === context.state.homepage.toLowerCase()) {
            homeIndex = i
          }
          if (element.ID.toLowerCase() === data.page.toLowerCase()) {
            if (element.Cultures.hasOwnProperty(context.state.language)) {
              index = i
            } else {
              index = 'home'
            }
          }
        }

        var toHome = index === 'home'
        index = toHome ? homeIndex : index

        if (index > -1) {
          if (toHome) {
            resolve(context.state.language + '/')
          } else {
            context.commit('activePage', context.state.sitemap[index])
            resolve(false)
          }
        } else {
          resolve('not-found')
        }
      })
    },
    getPublicAccidentData (context, country) {
      var vm = this._vm
      return new Promise(function (resolve) {
        if (context.state.publicAccidentData || context.state.gettingPublicAccidentData) {
          resolve(context.state.publicAccidentData)
        } else {
          context.commit('setGettingPublicAccidentData', true)
          vm.$http({
            method: 'GET',
            url: `/PublicAccidents/${country}`,
            api: 'applications',
            auth: false
          }).then(function (response) {
            context.commit('setPublicAccidentData', response.data)
            resolve(response.data)
          }).catch(function (error) {
            context.dispatch('setSnack', {
              message: error.message
            })
          }).then(function () {
            context.commit('setGettingPublicAccidentData', false)
          })
        }
      })
    },
    setHomepage (context, page) {
      var vm = this._vm
      context.commit('setHomepage', page)
      vm.$http({
        method: 'PUT',
        url: '/general/homepage',
        api: 'website',
        headers: {
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(page),
        name: process.env.VUE_APP_NAME + '_' + context.state.language
      }).then((response) => {
        context.commit('setHomepage', page)
        context.dispatch('setSnack', {
          message: vm.$resx('Page.HomepageChanged', {}, context.state.language)
        })
      }).catch(function (err) {
        context.dispatch('setSnack', {
          message: err.message
        })
      })
    },
    setSitemap (context, json) {
      context.commit('setLastTheme', json.LatestThemes)
      context.commit('setUnpublishedThemes', json.UnpublishedThemes)
      context.commit('setPartners', json.Partners)
      context.commit('setStaff', json.Staff)
      context.commit('setDownloads', json.Downloads)
      context.commit('setDownloadGroups', json.DownloadGroups)
      context.commit('setCultures', json.Cultures)
      context.commit('setHomepage', json.Homepage)
      context.commit('setSitemap', json.Pages)
    },
    getSitemapJson (context) {
      var vm = this._vm
      return new Promise(function (resolve) {
        if (!context.state.gettingLocalSitemap && context.state.sitemap && context.state.sitemap.length === 0) {
          context.state.gettingLocalSitemap = true
          vm.$axios({
            method: 'GET',
            url: '/data/website.json?v=1'
          }).then(function (response) {
            context.dispatch('setSitemap', response.data)
            resolve(true)
          }).catch(function (err) {
            context.dispatch('setSnack', {
              message: err.message
            })
            context.dispatch('setSitemap', [])
            resolve(false)
          }).then(function () {
            context.state.gettingLocalSitemap = false
          })
        } else {
          resolve(true)
        }
      })
    },
    getSitemap (context, force) {
      var vm = this._vm
      force = force || false
      var forceMe = force && force !== 'init'

      return vm.$auth.via_getMe(forceMe).then(function (me) {
        if (!vm.$auth.via_local().isValid() || !me.AccessToViaAdmin) {
          window.sessionStorage.removeItem('can-edit')
          context.commit('setAdmin', false)
          context.commit('adminLanguage', 'nl-NL')
          // vm.$auth.via_logout()
          force = false
        }

        var canEdit = force === 'init' && window.sessionStorage.getItem('can-edit') === 'true'
        return new Promise(function (resolve) {
          context.commit('loading', true)
          if (force || canEdit) {
            vm.$http({
              method: 'GET',
              url: '/general/website',
              api: 'website',
              name: process.env.VUE_APP_NAME + '_' + context.state.language
            }).then(function (response) {
              window.sessionStorage.setItem('can-edit', true)
              context.dispatch('setSitemap', response.data)
              context.commit('setAdmin', true)
              resolve(true)
            }).catch(function (err) {
              context.dispatch('setSnack', {
                message: err.message
              })
              window.sessionStorage.removeItem('can-edit')

              if (!force || force === 'init') {
                context.dispatch('getSitemapJson').then(function (suc) {
                  resolve(suc)
                })
              }
            }).then(function () {
              context.commit('loading', false)
            })
          } else {
            window.sessionStorage.removeItem('can-edit')
            context.dispatch('getSitemapJson').then(function (suc) {
              context.commit('loading', false)
              resolve(suc)
            })
          }
        })
      })
    },
    getContentBlocks (context, force) {
      var vm = this._vm
      force = force || false
      return new Promise(function (resolve) {
        if (!force && context.state.contentBlocks[context.state.language] && context.state.contentBlocks[context.state.language].length > 0) {
          resolve()
        } else {
          vm.$http({
            method: 'GET',
            url: '/contentblocks',
            api: 'website',
            name: process.env.VUE_APP_NAME + '_' + context.state.language
          }).then((response) => {
            context.commit('setContentBlocks', response.data)
            resolve()
          }).catch(function (err) {
            context.dispatch('setSnack', {
              message: err.message
            })
          })
        }
      })
    },
    getThemes (context, force) {
      var vm = this._vm
      var settings
      var instance
      force = force || false
      return new Promise(function (resolve) {
        if (!force && context.state.themes && context.state.themes.length > 0) {
          resolve()
        } else {
          if (context.state.isAdmin) {
            instance = '$http'
            settings = {
              method: 'GET',
              url: '/themes',
              api: 'website',
              name: process.env.VUE_APP_NAME + '_' + context.state.language
            }
          } else {
            instance = '$axios'
            settings = {
              method: 'GET',
              url: '/data/themes.json'
            }
          }
          vm[instance](settings).then(function (response) {
            var themes = response.data.hasOwnProperty('Data') ? response.data.Data : response.data
            context.commit('setThemes', themes)
            if (Object.keys(context.state.previewTheme).length > 0) {
              for (var i = 0; i < themes.length; i++) {
                if (themes[i].ID === context.state.previewTheme.ID) {
                  context.commit('setPreviewTheme', themes[i])
                  break
                }
              }
            }
            resolve()
          }).catch(function (err) {
            context.dispatch('setSnack', {
              message: err.message
            })
          })
        }
      })
    },
    deleteFile (context, file) {
      var vm = this._vm
      return new Promise(function (resolve) {
        if (file) {
          vm.$http({
            method: 'DELETE',
            url: '/general/file/' + (file.hasOwnProperty('name') ? file.name : file),
            name: process.env.VUE_APP_NAME + '_' + context.state.language,
            api: 'website'
          }).then(function (response) {
            context.dispatch('setSnack', {
              message: vm.$resx('FileInput.FileDeleted', {}, context.state.language)
            })
            resolve(true)
          }).catch(function (err) {
            context.dispatch('setSnack', {
              message: err.message
            })
            resolve(false)
          })
        }
      })
    },
    setSnack (context, snack) {
      var props = {
        title: snack.title || '',
        message: snack.message || '',
        duration: snack.duration || 3000,
        button: snack.button || 'Oke',
        action: snack.action || null,
        color: snack.color || 'white',
        public: snack.public || false
      }
      if (!context.state.snackbar || context.state.snackbar.message === props.message) {
        var now = new Date().getTime()
        window.snackDiff = 0
        if (context.state.snackbar) {
          window.snackDiff = now - context.state.snackbar.started
        }
        if (window.snackTimer) {
          clearTimeout(window.snackTimer)
        }
        context.state.snackbar = props
        context.state.snackbar.started = now
        window.snackTimer = setTimeout(function () {
          context.state.snackbar = false
          if (context.state.waitingSnackbar.length > 0) {
            setTimeout(function () {
              var next = context.state.waitingSnackbar.splice(0, 1)
              context.dispatch('setSnack', next[0])
            }, 400)
          }
        }, (props.duration + window.snackDiff))
      } else {
        context.state.waitingSnackbar.push(props)
      }
    }
  }
})
